import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useMatomo } from '../context/matomo-context/matomoContext'

export const useTrackPageView = (options?: { enabled?: boolean; trackInitialPage?: boolean }) => {
  const { enabled = true, trackInitialPage = true } = options || {}
  const location = useLocation()
  const { trackPageView } = useMatomo()

  useEffect(() => {
    if (!enabled) return

    trackPageView(document.title, window.location.href)
  }, [location, trackPageView, enabled])

  useEffect(() => {
    if (!enabled || !trackInitialPage) return

    trackPageView(document.title, window.location.href)
  }, [])
}
